import { useCallback } from 'preact/compat';
import { useMemo, useState } from 'react';
import clsx from 'clsx';
export default function useTermsClasses() {
    const [shouldShakeTerms, setShouldShakeTerms] = useState(false);
    const animationLengthInMilliseconds = 1000;
    const handleClick = useCallback((formDisabled) => {
        console.log('Book not clicked: ', formDisabled);
        if (formDisabled) {
            // Only shake the terms if not already shaking
            if (!shouldShakeTerms) {
                setShouldShakeTerms(true);
                setTimeout(() => {
                    setShouldShakeTerms(false);
                }, animationLengthInMilliseconds);
            }
        }
    }, [shouldShakeTerms]);
    return {
        handleClick: (formDisabled) => handleClick(formDisabled),
        termsClasses: useMemo(() => clsx('terms', shouldShakeTerms && 'shake'), [shouldShakeTerms]),
    };
}
